import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Component from './ShopPremiumContent';
import Component_profile_shop from './ShopPremiumContent.profile_shop';

export default withFeatureBranch({
  profile_shop: Component_profile_shop,
})(Component);
